import React, { useEffect } from "react";
import logo from "../../assets/images/logos/logo-tasa.svg"
import { useNavigate } from 'react-router-dom';

export default function Home() {

    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (token) {
            navigate("/tablero");
        }
    }, [navigate]);

    return (
        <div className="relative z-10 flex items-end justify-center w-full min-h-screen py-16 bg-center bg-cover bg-movil md:bg-tablet lg:bg-web ">
            <div className="relative z-50">
                <div className="flex items-end justify-center py-5">
                    <div className="flex flex-col items-center justify-center gap-6">
                        {/* <button
                            className="text-white cursor-pointer rounded-2xl font-itcdemi bg-green 2xl:text-2xl 2xl:py-8 py-[15px] lg:py-4 px-12 sm:px-16 md:text-lg text-sm text-center lg:text-[14px]">
                            Ingresar con credenciales
                        </button> */}
                        <button
                            className={`text-white cursor-pointer rounded-2xl font-itcdemi bg-[#184A7D] 2xl:text-2xl 2xl:py-8 py-[15px] lg:py-4 sm:px-16 px-12 md:text-lg text-sm text-center lg:text-[14px]}`}
                            onClick={() => {
                                const clientId = "79f96301-5983-43fb-ba89-22701ec51f63";
                                const tenantId = "common";
                                const redirectUri = encodeURIComponent("https://tasa-balanzas.programate.pe/auth-microsoft");
                                const scope = encodeURIComponent("openid profile email User.Read");
                                const microsoftAuthUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&scope=${scope}&response_mode=query`;
                                window.location.href = microsoftAuthUrl;
                            }}
                        >
                            Ingresar con Microsoft
                        </button>
                    </div>
                </div>
            </div>
            <img src={logo} alt="logo-tasa" className="absolute z-40 lg:w-[15%] w-[25%] top-6 left-7 " />
        </div>
    );
}